import React from 'react';
import { motion } from 'framer-motion';

/**
 * Wraps a bottom-nav tab icon with:
 *  - a "becoming active" scale bump (1 → 1.18 → 1) for tactile feedback
 *  - a press-down whileTap micro-interaction
 * Pure presentation — no nav logic.
 */
export const NavIconBump = ({ isActive, children, dataTestId }) => (
  <motion.div
    data-testid={dataTestId}
    initial={false}
    animate={isActive ? 'active' : 'inactive'}
    variants={{
      active: {
        scale: [1, 1.18, 1],
        transition: { duration: 0.42, times: [0, 0.45, 1], ease: [0.34, 1.56, 0.64, 1] },
      },
      inactive: {
        scale: 1,
        transition: { duration: 0.2, ease: 'easeOut' },
      },
    }}
    whileTap={{ scale: 0.9, transition: { duration: 0.12 } }}
    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', willChange: 'transform' }}
  >
    {children}
  </motion.div>
);

/**
 * The shared brand-orange "glide pill" rendered by the active tab. Its
 * `layoutId` lets Framer Motion smoothly translate it between tabs on every
 * route change.
 */
export const NavActivePill = ({ layoutId, dataTestId }) => (
  <motion.div
    layoutId={layoutId}
    data-testid={dataTestId}
    transition={{ type: 'spring', stiffness: 380, damping: 30, mass: 0.6 }}
    style={{
      position: 'absolute',
      top: 'calc(50% + 16px)',
      // Centre via left + negative margin so framer-motion's layoutId transform
      // (which it applies to the element while gliding between tabs) doesn't
      // fight a CSS translateX(-50%). Pill width is 22px → marginLeft -11px.
      left: '50%',
      marginLeft: -11,
      width: 22,
      height: 3,
      borderRadius: 999,
      backgroundColor: 'var(--accent-purple)',
      boxShadow: '0 1px 6px var(--accent-purple)',
      pointerEvents: 'none',
    }}
  />
);

export default NavIconBump;
